import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';

export class WebpackTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return Observable.fromPromise(System.import(`../assets/translations/${lang}.json`));
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/webpack-translate-loader.ts